function localDateTimeFormatter(utcString, includeTime = true) {
  // Check if date string is in UTC format (has 'Z' or timezone info)
  // If not, treat it as UTC by appending 'Z'
  let dateString = utcString
  if (
    typeof utcString === 'string' &&
    !utcString.endsWith('Z') &&
    !utcString.includes('+') &&
    !utcString.includes('T')
  ) {
    // Convert "2025-11-22 12:30:00" format to UTC
    dateString = utcString.replace(' ', 'T') + 'Z'
  }

  const date = new Date(dateString)

  const day = date.getDate()
  const month = date.toLocaleString('en-US', { month: 'short' })
  const year = String(date.getFullYear())

  if (!includeTime) {
    return `${day} ${month} ${year}`
  }

  let hours = date.getHours()
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const ampm = hours >= 12 ? 'pm' : 'am'

  hours = hours % 12 || 12 // convert 0 → 12

  return `${day} ${month} ${year}, ${hours}:${minutes} ${ampm}`
}

export default localDateTimeFormatter
